var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAryaEssentialPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.06 134.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#232326;}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-5);}.cls-5{fill:#e69742;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1933.18,
    y1: -3006.45,
    x2: -1932.18,
    y2: -3006.45,
    gradientTransform: "translate(-128239.68 590257.11) rotate(45) scale(168.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e69742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e69742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b34126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b34126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1933.18,
    y1: -3006.34,
    x2: -1932.18,
    y2: -3006.34,
    gradientTransform: "translate(-128239.68 590257.11) rotate(45) scale(168.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7dec2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f7dec2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#e7c2b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7c2b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: -3006.33,
    x2: -1932.18,
    y2: -3006.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1933.18,
    y1: -3006.33,
    x2: -1932.18,
    y2: -3006.33,
    gradientTransform: "translate(-128239.68 590257.11) rotate(45) scale(168.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f0c391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d39181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d39181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1933.18,
    y1: -3006.33,
    x2: -1932.18,
    y2: -3006.33,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.17,77.85h-28.65l-4.11,7.86c-1.5,2.73-2.94,3.76-5.2,3.76-2.49,.04-4.54-1.95-4.58-4.44h0c.07-1.22,.45-2.4,1.1-3.42l18.8-35.56c2.8-5.13,5.47-5.81,8.34-5.81s5.41,.68,8.27,5.81l18.94,35.56c.62,1.04,.97,2.21,1.02,3.42,0,2.46-2,4.45-4.46,4.44h-.05c-2.26,0-3.76-.96-5.26-3.76l-4.17-7.86Zm-23.93-8.89h19.27l-9.64-18.39-9.63,18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.94,84.68c0,2.64-2.14,4.79-4.79,4.79s-4.79-2.14-4.79-4.79V50.16c0-8.41,2.53-9.23,9.57-9.23h20.51c9.51,0,16.07,5.88,16.07,15.38,.15,6.49-4.08,12.28-10.32,14.08l8.41,10.19c1.3,1.22,2.11,2.87,2.26,4.65-.1,2.43-2.15,4.32-4.58,4.24-1.78,0-3.22-.62-5.26-3.21l-11.42-14.57h-15.66v12.99Zm19.83-34.87h-18.46c-1.37,0-1.37,.69-1.37,2.05v10.94h19.83c5.26,0,7.18-2.6,7.18-6.49s-1.91-6.5-7.18-6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.61,84.68c.02,2.64-2.11,4.8-4.75,4.82-2.64,.02-4.8-2.11-4.82-4.75v-16.47l-21.33-19.69c-1-.91-1.6-2.2-1.64-3.55-.13-2.52,1.81-4.66,4.33-4.79,.17,0,.34,0,.52,0,1.35,.03,2.62,.6,3.55,1.57l19.35,17.98,19.35-17.98c.93-.97,2.21-1.54,3.55-1.57,2.52-.16,4.69,1.75,4.85,4.27,.01,.17,.01,.34,0,.52-.05,1.36-.64,2.64-1.64,3.55l-21.33,19.69v16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.11,77.85h-28.65l-4.11,7.86c-1.51,2.73-2.94,3.76-5.19,3.76-2.49,.04-4.54-1.95-4.58-4.44h0c.07-1.22,.45-2.4,1.09-3.42l18.81-35.56c2.8-5.13,5.47-5.81,8.34-5.81s5.4,.68,8.27,5.81l18.94,35.56c.62,1.03,.98,2.21,1.03,3.42,0,2.46-2,4.45-4.45,4.44h-.06c-2.26,0-3.76-.96-5.27-3.76l-4.17-7.86Zm-23.93-8.89h19.28l-9.64-18.39-9.64,18.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.38 106.77 273.34 106.77 273.34 113.88 280.56 113.88 280.56 115.46 273.34 115.46 273.34 122.68 281.38 122.68 281.38 124.26 271.43 124.26 271.43 105.2 281.38 105.2 281.38 106.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.28,124.48c-3.38,0-5.75-1.69-5.99-4.41h1.96c.16,1.63,1.58,2.8,4,2.8,2.12,0,3.32-1.14,3.32-2.56,0-3.68-8.93-1.53-8.93-7.11,0-2.21,2.1-4.03,5.23-4.03s5.28,1.69,5.45,4.55h-1.91c-.11-1.66-1.33-2.91-3.59-2.91-1.99,0-3.24,1.06-3.24,2.37,0,4.03,8.8,1.88,8.88,7.13,0,2.4-2.1,4.17-5.17,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304.2,124.48c-3.38,0-5.75-1.69-5.99-4.41h1.96c.16,1.63,1.58,2.8,4,2.8,2.12,0,3.32-1.14,3.32-2.56,0-3.68-8.93-1.53-8.93-7.11,0-2.21,2.1-4.03,5.23-4.03s5.28,1.69,5.45,4.55h-1.91c-.11-1.66-1.33-2.91-3.59-2.91-1.99,0-3.24,1.06-3.24,2.37,0,4.03,8.8,1.88,8.88,7.13,0,2.4-2.1,4.17-5.17,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M319.42,124.48c-4.22,0-7.3-2.94-7.3-7.65s3.02-7.65,7.3-7.65,7.03,3.1,7.03,6.89c0,.6,0,.98-.05,1.5h-12.34c.16,3.49,2.59,5.31,5.37,5.31,2.53,0,4.25-1.33,4.79-3.32h2.02c-.68,2.8-3.08,4.93-6.81,4.93Zm-5.37-8.47h10.46c.08-3.46-2.42-5.2-5.17-5.2s-5.07,1.74-5.28,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.1,115.76c0-3.29-1.8-4.98-4.52-4.98s-4.71,1.74-4.71,5.37v8.12h-1.91v-14.87h1.91v2.53c.95-1.85,2.86-2.8,5.07-2.8,3.38,0,6.05,2.07,6.05,6.43v8.71h-1.88v-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M347.77,111h-2.07v-1.61h2.07v-3.73h1.93v3.73h4.09v1.61h-4.09v9.23c0,1.83,.63,2.4,2.34,2.4h1.74v1.63h-2.04c-2.59,0-3.98-1.06-3.98-4.03v-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.51,105.17c0-.82,.63-1.39,1.39-1.39s1.39,.57,1.39,1.39-.63,1.42-1.39,1.42-1.39-.6-1.39-1.42Zm.44,4.22h1.91v14.87h-1.91v-14.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369.45,109.17c3,0,5.04,1.61,5.88,3.49v-3.27h1.91v14.87h-1.91v-3.29c-.87,1.91-2.94,3.51-5.91,3.51-4.06,0-7.08-3.02-7.08-7.68s3.02-7.62,7.11-7.62Zm.35,1.66c-3.13,0-5.53,2.18-5.53,5.96s2.4,6.02,5.53,6.02,5.53-2.29,5.53-5.99-2.48-5.99-5.53-5.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 381.62,
    y: 104.11,
    width: 1.91,
    height: 20.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "403 107.24 403 113.37 409.07 113.37 409.07 115 403 115 403 121.13 401.23 121.13 401.23 115 395.18 115 395.18 113.37 401.23 113.37 401.23 107.24 403 107.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.35,100.32l-.16-.16,.05-.12,33.16-33.04h.23l11.09,10.59,.05,.14-.09,.12-44.26,22.44-.07,.02m-2.14,.12h-.06l-.1-.16V33.4c0-.09,.08-.16,.16-.16h0l.11,.04,34.28,32.72,.05,.11-.05,.12-34.27,34.16-.12,.05M108.76,0H25.91C11.6,0,0,11.6,0,25.91V108.76c0,14.31,11.6,25.91,25.91,25.91H108.76c14.31,0,25.91-11.6,25.91-25.91V25.91c0-14.31-11.6-25.91-25.91-25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "72.52 67.34 40.19 99.54 83.33 77.66 72.52 67.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.19,99.54l32.33-32.21,10.81,10.32-43.14,21.89m32.44-32.54h-.23l-33.16,33.04-.05,.12,.16,.16,.07-.02,44.26-22.44,.09-.12-.05-.14-11.09-10.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "37.37 33.78 37.37 99.89 71.25 66.13 37.37 33.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.37,99.89V33.78l33.88,32.34-33.88,33.76m-.16-66.65c-.09,0-.16,.07-.16,.16V100.28l.1,.15h.06l.12-.04,34.27-34.16,.05-.12-.05-.11L37.32,33.29l-.11-.04h0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.99 33.14 84.95 77.01 105.21 66.74 38.99 33.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.95,77.18l-.11-.05L38.87,33.25v-.23l.18-.03,66.23,33.6,.07,.22-.07,.07-20.26,10.28-.08,.02ZM39.89,33.78l45.09,43.04,19.87-10.08L39.89,33.78Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAryaEssentialPlus);
export default __webpack_public_path__ + "static/media/arya-essential-plus.0eac4787c1e1988e2cff9029375421c7.svg";
export { ForwardRef as ReactComponent };